function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Mask from "../../../eden-platform-mask";
import Lock from "../../../eden-body-lock";
import HotKey from "../../../eden-hotkey";
import { spacing8, spacing16, spacing32, spacing48, spacing96, grey10 } from "../../../eden-style-constants";
import EdenCard from "../../../eden-card";
import { Icon } from "../../../eden-buttons";
import { Clear } from "../../../eden-icons";
import { Title5 } from "../../../eden-headings";

const capture = e => e.key === "Escape" || e.key === "Tab" || e.stopPropagation();

const ModalMask = styled(Mask).withConfig({
  componentId: "sc-7cm3zw-0"
})(["display:flex;justify-content:center;align-items:flex-start;overflow:auto;@media (min-width:25rem){padding:", " 0;}"], spacing48);
const ClickableArea = styled.div.withConfig({
  componentId: "sc-7cm3zw-1"
})(["position:absolute;z-index:1;left:0;right:0;top:0;bottom:0;"]);
const Card = styled(EdenCard).withConfig({
  componentId: "sc-7cm3zw-2"
})(["z-index:2;margin:auto;max-height:100vh;overflow:auto;@media (min-width:25rem){max-height:calc(100vh - ", ");}"], spacing96);
const ModalHeader = styled.header.withConfig({
  componentId: "sc-7cm3zw-3"
})(["display:flex;", ";align-items:center;padding:", " ", ";padding-inline-end:", ";"], ({
  hasHeader
}) => hasHeader ? `justify-content: space-between; border-bottom: 1px solid ${grey10}` : "justify-content: flex-end", ({
  hasCloseGesture
}) => hasCloseGesture ? spacing8 : spacing16, spacing32, spacing8);

const PlatformModal = ({
  active,
  children,
  onCloseGesture,
  heading,
  type,
  ...props
}) => {
  if (!active) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ModalMask, _extends({
    type: type,
    active: active,
    role: "dialog"
  }, props), /*#__PURE__*/React.createElement(Lock, {
    active: active
  }), onCloseGesture && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClickableArea, {
    onClick: onCloseGesture
  }), /*#__PURE__*/React.createElement(HotKey, {
    sequence: ["Escape"],
    onMatch: onCloseGesture
  })), /*#__PURE__*/React.createElement(Card, {
    onClick: capture,
    onKeyDown: capture,
    depth: "poppedOut"
  }, onCloseGesture || heading ? /*#__PURE__*/React.createElement(ModalHeader, _extends({
    hasHeader: heading,
    hasCloseGesture: onCloseGesture
  }, props), heading ? /*#__PURE__*/React.createElement(Title5, null, heading) : null, onCloseGesture ? /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    onClick: onCloseGesture
  }, /*#__PURE__*/React.createElement(Clear, null)) : null) : null, children));
};

PlatformModal.propTypes = {
  /** Modal content */
  children: PropTypes.node.isRequired,

  /** Whether modal is open */
  active: PropTypes.bool,

  /** Callback to execute when the modal closes */
  onCloseGesture: PropTypes.func,

  /** Receives a string to determine light or dark scrim "media" = dark "normal" = light for the Modal Mask Component*/
  type: PropTypes.oneOf(["media", "normal"]),

  /** An element or string to display in the heading slot */
  heading: PropTypes.node
};
export default PlatformModal;